import { useT } from '@hooks';
import React from 'react';
import checkTheme from '../../../../../src/utils/custom/checkTheme';

import s from './index.module.scss';

function statisticBlock() {
	const { T } = useT();
	return (
		<div className={`${s.statisticBlock} ${s[checkTheme()]}`}>
			<h2 className={s.statisticBlockTitle}>{T('new_subscritions_join')}</h2>
			<div className={s.statisticBlockItems}>
				<div className={s.statisticBlockItem}>
					<div className={s.statisticBlockItemTop}>4.9</div>
					<div className={s.statisticBlockItemBottom}>{T('statistic_block_item1_text')}</div>
				</div>
				<div className={s.statisticBlockItem}>
					<div className={s.statisticBlockItemTop}>54K</div>
					<div className={s.statisticBlockItemBottom}>{T('statistic_block_item2_text')}</div>
				</div>
				<div className={s.statisticBlockItem}>
					<div className={s.statisticBlockItemTop}>70M+</div>
					<div className={s.statisticBlockItemBottom}>{T('statistic_block_item3_text')}</div>
				</div>
			</div>
		</div>
	);
}

export default statisticBlock;
